import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaCalendarAlt, FaWhatsapp } from 'react-icons/fa';

const StickyReserveButton = ({ onReserveClick }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  const handleWhatsApp = () => {
    window.open(
      'https://wa.me/51947791970?text=Hola%2C%20me%20gustar%C3%ADa%20obtener%20m%C3%A1s%20informaci%C3%B3n%20sobre%20Sumaq%20Mayu.',
      '_blank'
    );
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 50 }}
          transition={{ duration: 0.3 }}
          className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3"
        >
          <motion.button
            onClick={handleWhatsApp}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            className="text-white rounded-full shadow-lg flex items-center justify-center focus:outline-none"
            style={{
              background: '#25D366',
              width: '56px',
              height: '56px',
              boxShadow: '0 4px 15px rgba(37, 211, 102, 0.4)',
            }}
            aria-label="Contáctanos por WhatsApp"
          >
            <FaWhatsapp className="text-2xl" />
          </motion.button>
          <motion.button
            onClick={onReserveClick}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="bg-green-600 text-white rounded-full shadow-lg flex items-center justify-center space-x-2
                       hover:bg-green-700 transition-colors duration-300 text-base sm:text-lg focus:outline-none"
            style={{ minWidth: '60px', minHeight: '60px', width: 'auto', paddingLeft: '1.5rem', paddingRight: '1.5rem' }}
          >
            <FaCalendarAlt className="text-xl" />
            <span className="hidden sm:inline">Reservar Ahora</span>
          </motion.button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default StickyReserveButton;
